import { memo, useCallback, useState } from "react";
import Demo from "./Demo/Demo";
import Name from "./Name/Name";
import Highlight from "./Highlight/Highlight";
import { FixaListView } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListView";
import Actions from "./Actions/Actions";
import FixaCheckbox from "@coworker/apprestructured/src/shared/wrappers/FixaCheckbox/FixaCheckbox";
import TextModal from "@coworker/apprestructured/src/task-management/components/TextModal/TextModal";
import { FixaInputField } from "@coworker/apprestructured/src/shared/wrappers/FixaInputField/FixaInputField";

function TextModalDemo() {
  const [text, setText] = useState<string>("");
  const [title, setTitle] = useState<string>("Location");
  const [disabled, setDisabled] = useState(false);

  const handleConfirmClick = useCallback((text: string) => {
    setText(text);
  }, []);

  return (
    <Demo>
      <Name>TextModal</Name>
      <Highlight>
        <FixaListView id="textmodal" size="small">
          <TextModal
            title={title}
            text={text}
            onConfirmClick={handleConfirmClick}
            disabled={disabled}
          />
        </FixaListView>
      </Highlight>
      <Actions>
        <FixaCheckbox
          label="disabled"
          value="textmodal-disabled"
          id="textmodal-disabled"
          checked={disabled}
          onChange={() => setDisabled((prev) => !prev)}
        />
        <FixaInputField
          id="title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          type="text"
          label="title"
        />
      </Actions>
    </Demo>
  );
}

export default memo(TextModalDemo);
